
const baseMessage = require('@/system/locales/hsb/zh-cn.js');

module.exports = baseMessage;



// WEBPACK FOOTER //
// ./src/projects/hsbpc/locales/zh-CN.js